import React, { useState } from 'react';
import { Page, Document, pdfjs } from 'react-pdf';
import Modal from 'react-modal';
import { Button } from '@mui/material';

pdfjs.GlobalWorkerOptions.workerSrc =
  `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

// 再レンダリングごとに新しいオブジェクトを作らない
const pdfOptions = {
  cMapUrl: `${process.env.PUBLIC_URL}/cmaps/`,
  cMapPacked: true,
  standardFontDataUrl:
    `${process.env.PUBLIC_URL}/standard_fonts/`,
  useSystemFonts: true,
};

Modal.setAppElement('#root');

export default function PdfModalViewer({
  filePath,
  isOpen,
  onClose,
  startPage = 1,
  endPage,
}) {
  const [numPages, setNumPages] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');

  const handleLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setErrorMessage('');
  };

  const actualEndPage = endPage
    ? Math.min(endPage, numPages)
    : numPages;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="PDF Viewer"
      style={{
        overlay: {
          zIndex: 1300,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        content: {
          width: '90%',
          height: '90%',
          margin: 'auto',
          overflow: 'auto',
          zIndex: 1400,
        },
      }}
    >
      <Button onClick={onClose} variant="outlined">
        閉じる
      </Button>

      {errorMessage && (
        <div
          style={{
            color: '#d32f2f',
            padding: '16px 0',
          }}
        >
          {errorMessage}
        </div>
      )}

      <style>
        {`
          .pdf-content {
            width: 120%;
          }

          @media only screen and (max-width: 610px) {
            .pdf-content { width: 130%; }
          }

          @media only screen and (max-width: 560px) {
            .pdf-content { width: 150%; }
          }

          @media only screen and (max-width: 500px) {
            .pdf-content { width: 180%; }
          }

          @media only screen and (max-width: 440px) {
            .pdf-content { width: 210%; }
          }

          @media only screen and (max-width: 390px) {
            .pdf-content { width: 250%; }
          }

          @media only screen and (max-width: 350px) {
            .pdf-content { width: 290%; }
          }
        `}
      </style>

      <div className="pdf-content">
        <Document
          file={`${process.env.PUBLIC_URL}${filePath}`}
          options={pdfOptions}
          onLoadSuccess={handleLoadSuccess}
          onLoadError={(error) => {
            console.error('PDF load error:', error);
            setErrorMessage(
              `PDFの読み込みに失敗しました：${error.message}`
            );
          }}
          loading="読み込み中..."
          error="PDFの読み込みに失敗しました。"
        >
          {numPages > 0 &&
            Array.from(
              {
                length: Math.max(
                  0,
                  actualEndPage - startPage + 1
                ),
              },
              (_, index) => {
                const pageNumber = startPage + index;

                return (
                  <div
                    key={`wrapper_${pageNumber}`}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginBottom: '20px',
                    }}
                  >
                    <Page
                      pageNumber={pageNumber}
                      width={800}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                      onRenderError={(error) => {
                        console.error(
                          `Page ${pageNumber} render error:`,
                          error
                        );

                        setErrorMessage(
                          `${pageNumber}ページ目の描画に失敗しました：${error.message}`
                        );
                      }}
                    />
                  </div>
                );
              }
            )}
        </Document>
      </div>
    </Modal>
  );
}